/** @module csi/widget/_svg/ModeLine */
define([
	"dijit/form/ToggleButton",
	"csi/_base/underscore",
	"./_Plugin",
	"./PluginFactory"
], function(ToggleButton,_,_Plugin,PluginFactory) {

	return PluginFactory.declare([ToggleButton, _Plugin], {
		"class": "csi-button-toggle",
		fill: false,
		iconClass: "csiActionIcon svgIconLine",
		pluginName: "line",
		title: "CanvasLine",
		tagShape: "line",

		/**
		 * Enable and disable the line mode
		 * @param {Shape[]} shapes
		 * @param {Object} shapeAttrs
		 * @param {Object} textAttrs
		 * @return {boolean}
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			if (!this.editor.isDrawMode(this.tagShape) || (shapes && shapes.length)) {
				this.set('checked', false);
			}
			return true;
		},

		/**
		 * Invoke draw line action
		 */
		onClick: function() {
			this.editor.setDrawMode('line');
			this.set('checked', true);
		}
	});
});
